import api from "../../services/apiEndpoints";
import { Modal } from "bootstrap";
import auth from "../../services/auth";
import moment from "moment";
import messages from "../../services/messages";
import $ from "jquery";
import _ from "lodash";
import general from "../../services/general";

export const appointmentsMixin = {
    methods: {
        confirmAppointment(id, isCalendar = true) {
            let data = {
                id: id,
            };

            this.$http.post(api.actions.confirm_appointment, data).then((response) => {
                if (!response.data.error) {
                    this.newCurrentStylist = this.newUsers.find((usr) => usr.user.id == this.newCurrentStylistId);

                    this.numberOfDataFetched = 0;
                    this.totalNumberOfDataToFetch = 2;

                    if (isCalendar) {
                        this.newGetDisabledTimes(this.newCurrentStylist);
                    }

                    this.newGetAppointments(this.newCurrentStylist);
                    this.resetData();

                    const eventModalEl = document.getElementById("event-modal");
                    const eventModalInstance = Modal.getInstance(eventModalEl) || new Modal(eventModalEl);
                    eventModalInstance.hide();

                    const eventByStatusModalEL = document.getElementById("event-by-status-modal");
                    const eventByStatusModal = Modal.getInstance(eventByStatusModalEL);

                    if (eventByStatusModal) {
                        eventByStatusModal.hide();
                    }

                    this.$swal(
                        this.$t("adminDashboard.details.titleConfirmed"),
                        this.$t("adminDashboard.details.msgConfirmed"),
                        "success",
                    );
                }
            });
        },

        cancelAppointment(allRecurring = false, noShow = false) {
            let data = {
                id: this.cancelAppointmentInProgressId,
            };

            if (!this.cancelAppointmentInProgressId) {
                return;
            }

            if (noShow) {
                data.cancel_details = "no_show";
            }

            if (allRecurring) {
                data.cancel_recurring = 1;
            }

            if (noShow) {
                data.cancel_details = "no_show";
            }

            this.$http.post(api.actions.cancel_appointment, data).then((response) => {
                if (!response.data.error) {
                    this.cancelAppointmentInProgressId = 0;
                    this.newCurrentStylist = this.newUsers.find((user) => user.user.id == this.newCurrentStylistId);
                    this.numberOfDataFetched = 0;
                    this.totalNumberOfDataToFetch = 2;
                    this.newGetDisabledTimes(this.newCurrentStylist);
                    this.newGetAppointments(this.newCurrentStylist);
                    this.resetData();

                    const eventModalEl = document.getElementById("event-modal");
                    const eventModalInstance = Modal.getInstance(eventModalEl) || new Modal(eventModalEl);
                    eventModalInstance.hide();

                    const cancelApptModalEl = document.getElementById("cancel-appt-modal");
                    const cancelApptModalInstance =
                        Modal.getInstance(cancelApptModalEl) || new Modal(cancelApptModalEl);
                    cancelApptModalInstance.hide();
                    this.$swal(
                        this.$t("adminDashboard.details.titleCanceled"),
                        this.$t("adminDashboard.details.msgCanceled"),
                        "success",
                    );
                }
            });
        },

        onCancelAppointment(id) {
            this.cancelAppointmentInProgressId = id;

            this.$http
                .get(api.actions.get_appointment_details + id + "?webRequest=1")
                .then((response) => {
                    // arrow function preserves 'this'
                    if (response.data.details.personal == 1) {
                        this.cancelAppointment();
                        return;
                    }

                    let html = this.getButtons();

                    let cancelRecurringHtml = "";

                    if (auth.state.user.role == "client" && this.appointment_details.details.cancel_fee) {
                        cancelRecurringHtml +=
                            '<div class="mt-3">You will be charged with ' +
                            this.appointment_details.details.cancel_fee +
                            " " +
                            this.appointment_details.details.currency +
                            ".</div>";
                    }

                    if (response.data && response.data.details && response.data.details.recurring) {
                        cancelRecurringHtml += this.addCancelRecurringButton();
                    }

                    const eventModalEl = document.getElementById("event-modal");
                    const eventModalInstance = Modal.getInstance(eventModalEl) || new Modal(eventModalEl);
                    eventModalInstance.hide();

                    if (this.user.role == "stylist") {
                        const cancelApptModalEl = document.getElementById("cancel-appt-modal");
                        const cancelApptModalInstance =
                            Modal.getInstance(cancelApptModalEl) || new Modal(cancelApptModalEl);
                        cancelApptModalInstance.show();
                        return;
                    }

                    let customClassApp = "rms-app";
                    document.querySelector("body").classList.add("rms-app");

                    if (this.generalOptions.app_id === 2) {
                        customClassApp = "rmb-app";
                        document.querySelector("body").classList.add("rmb-app");
                    } else if (this.generalOptions.app_id === 5) {
                        customClassApp = "rml-app";
                        document.querySelector("body").classList.add("rml-app");
                    }

                    this.$swal({
                        title: this.$t("adminDashboard.details.cancelAppointment"),
                        text: this.$t("adminDashboard.details.cancelAppointmentText"),
                        customClass: customClassApp,
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonText: this.$t("adminDashboard.details.cancelAppointmentYes"),
                        cancelButtonText: this.$t("adminDashboard.details.cancelAppointmentNo"),
                    }).then((result) => {
                        if (result.value) {
                            this.cancelAppointment();
                            return;
                        }
                        this.cancelAppointmentInProgressId = 0;
                    });
                })
                .catch((error) => {
                    console.error("Error fetching appointment details:", error);
                    this.cancelAppointmentInProgressId = 0;
                });
        },

        newManageSaveAppointmentButton() {
            let active = false;
            active = this.bookData.date && this.hour;

            if (this.apptClientSelected) {
                active = this.newSelectedServices.length && this.newSelectedModalClient.id;
            }
            this.newDisableSave = !active;
        },

        searchAppointment() {
            if (this.searchQuery.length < 3) {
                return;
            }

            let user_ids = [];
            this.newUsers.forEach((user) => {
                user_ids.push(user.user.id);
            });

            this.loading = true;
            this.$http
                .post(api.actions.search_appointments, {
                    search_string: this.searchQuery,
                    user_ids: user_ids,
                })
                .then(
                    function (response) {
                        this.filteredAppointments = response.data.filteredAppointments;
                        if (!response.data.filteredAppointments.length) {
                            this.searchError = "There are no search results for this query.";
                        }
                        this.loading = false;
                    }.bind(this),
                    function () {
                        this.loading = false;
                        return false;
                    },
                );
        },

        viewAppointmentDetails(appt) {
            this.newOnEventClick({
                event: {
                    id: appt.id,
                },
                extendedProps: {
                    user_id: this.user.id,
                },
            });
        },

        onRescheduleAppointment(id) {
            this.newRescheduleInProgress = true;
            this.$http.get(api.actions.get_appointment_details + id + "?webRequest=1").then(
                function (response) {
                    if (response.data) {
                        let details = response.data.details;
                        let selected_services = _.filter(response.data.services, {
                            selected: 1,
                        });

                        let selected_service_ids = _.map(selected_services, (el) => {
                            return el.service_id;
                        });
                        let selected_service_names = _.map(selected_services, (el) => {
                            return el.service_name;
                        });

                        selected_services.map((service) => {
                            this.selectedServiceQty[service.service_id] = service.service_quantity;
                        });

                        this.bookData = {
                            id: details.id,
                            stylist_id: details.user_id,
                            client_id: details.client_id,
                            services: selected_service_ids,
                            selected_service_qty: this.selectedServiceQty,
                            date: moment(details.date).toDate(),
                            original_date: moment(details.date).toDate(),
                            special_event: details.special_event,
                            notes: details.notes,
                            reminders: details.reminders.split(","),
                        };

                        this.bookData.reschedule = true;

                        this.notes = details.notes;

                        //manage recurring
                        if (typeof details.recurring !== "undefined" && details.recurring) {
                            this.recurring = details.recurring;
                        }
                        if (this.recurring && typeof details.recurring_details !== "undefined") {
                            if (typeof details.recurring_details.repeat_every !== "undefined") {
                                this.repeatEvery = details.recurring_details.repeat_every;
                            }
                            if (typeof details.recurring_details.repeat_period !== "undefined") {
                                this.repeatPeriod = details.recurring_details.repeat_period;
                            }
                            if (typeof details.recurring_details.repeat_times !== "undefined") {
                                this.repeatTimes = details.recurring_details.repeat_times;
                            }
                        }

                        this.previewData = {
                            stylistName: "",
                            services: selected_service_names,
                        };

                        if (details.user_id == auth.state.user.id) {
                            this.selectedStylist = auth.state.user;
                        } else {
                            let stylist = _.filter(this.newUsers, {
                                user: { id: details.user_id },
                            });

                            if (stylist.length > 0) {
                                this.selectedStylist = stylist[0].user;
                            }
                        }

                        let client = _.filter(this.newClients, {
                            id: details.client_id,
                        });

                        if (client.length > 0) {
                            this.selectedClient = client[0];
                        }

                        const eventModalEl = document.getElementById("event-modal");
                        const eventModalInstance = Modal.getInstance(eventModalEl) || new Modal(eventModalEl);
                        eventModalInstance.hide();

                        if (auth.state.user.role == "stylist") {
                            this.currentSection = 2;

                            this.newCurrentStylistId = this.selectedStylist.id;
                            this.newCurrentStylist = this.newUsers.find(
                                (user) => user.user.id == this.newCurrentStylistId,
                            );
                            //select the client
                            if (
                                typeof details.client !== "undefined" &&
                                typeof details.client.first_name !== "undefined" &&
                                typeof details.client.last_name !== "undefined" &&
                                typeof details.client.id !== "undefined"
                            ) {
                                this.newSelectedModalClient = {
                                    first_name: details.client.first_name,
                                    last_name: details.client.last_name,
                                    id: details.client.id,
                                };
                            } else {
                                this.newSelectedModalClient = _.find(this.newPagedClients, function (client) {
                                    return client.id == details.client_id;
                                });
                            }

                            if (this.newSelectedModalClient) {
                                this.newIsClientSelected = true;
                            }

                            //select the services
                            this.newTotalCostServices = 0;
                            this.newSelectedServices = [];
                            this.newMakeListServices();

                            let targetService = _.filter(this.newServicesArray, function (service) {
                                return selected_service_ids.indexOf(service.id) != -1;
                            });

                            if (Object.keys(targetService).length) {
                                this.newSelectedServices = targetService;
                                let allServices;
                                let totalCost;
                                this.newSelectedServices.forEach((element) => {
                                    const serviceQuantity = this.selectedServiceQty[element.id];

                                    //making selected services in string
                                    if (allServices) {
                                        allServices = allServices + ", " + element.name;
                                    } else {
                                        allServices = element.name;
                                    }
                                    //make total cost
                                    if (totalCost) {
                                        totalCost = totalCost + element.price * serviceQuantity;
                                    } else {
                                        totalCost = element.price * serviceQuantity;
                                    }
                                });
                                this.newSelectedServicesString = allServices;
                                this.newTotalCostServices = totalCost;

                                //total cost logic ends
                                this.newTotalDurationServices = details.total_duration;

                                if (this.newSelectedServices.length) {
                                    this.newShowSelectedServices = true;
                                } else {
                                    this.newShowSelectedServices = false;
                                }

                                if (this.newTotalCostServices > 0) {
                                    this.newShowTotalCost = true;
                                } else {
                                    this.newShowTotalCost = false;
                                }

                                if (this.newTotalDurationServices > 0) {
                                    this.newShowTotalDuration = true;
                                } else {
                                    this.newShowTotalDuration = false;
                                }

                                //enable save button
                                if (this.newSelectedServices.length) {
                                    this.newDisableSaveServices = false;
                                } else {
                                    this.newDisableSaveServices = true;
                                }
                            }

                            //select the date
                            this.day = moment(this.bookData.date).format("ddd");
                            this.date = moment(this.bookData.date).format("l");
                            this.hour = moment(this.bookData.date).format("hh:mm A");

                            //show the modal
                            const dateModalEl = document.getElementById("date-modal");
                            const dateModalInstance = Modal.getInstance(dateModalEl) || new Modal(dateModalEl);
                            if (dateModalInstance) {
                                dateModalInstance.show();
                            }

                            this.newOnDateClick({
                                date: this.bookData.date,
                            });

                            this.newManageSaveAppointmentButton();
                        } else {
                            this.currentSection = 1;
                            this.$router.push("/app/book/" + details.user_id);
                        }
                    }
                }.bind(this),
            );
        },

        newSaveAppointment() {
            if (this.newTotalDurationServices <= 0) {
                messages.errorMessage(messages.GLOBAL_MESSAGES.NO_SERVICES_SELECTED);
                return;
            }

            //validate recurring related inputs
            if (this.recurring) {
                this.repeatEvery = parseInt(this.repeatEvery);
                if (this.repeatPeriod != "day" && (this.repeatEvery < 1 || this.repeatEvery > 99)) {
                    messages.errorMessage("Repeat every value should be between 0 and 100");
                    return;
                }

                this.repeatTimes = parseInt(this.repeatTimes);
                if (this.repeatTimes < 1 || this.repeatTimes > 99) {
                    messages.errorMessage("Occurrences value should be between 0 and 100");
                    return;
                }
            }

            //so that user doenst multi click
            this.newDisableSave = true;
            let selectedServicesID = [];

            this.newSelectedServices.forEach(function (serviceId) {
                selectedServicesID.push(serviceId.id);
            });

            let formattedDate = moment(this.bookData.date).format("YYYY-MM-DD");
            let stylist_id = this.newCurrentStylistId;

            if (this.user.role == "client" && stylist_id == this.user.id) {
                stylist_id = this.bookData.stylist_id;
            }

            //preparing object for personal appointment
            let data = {
                personal: true,
                user_id: stylist_id,
                client_id: 0,
                date_time: formattedDate,
                hour: this.hour,
                services: [],
                new_services: this.getServicesQty(),
                notes: this.notes,
                special_event: "",
                reminders: "",
                status: "unconfirmed",
                check_time_limit: 1,
                total_duration: this.newTotalDurationServices,
                update_recurring: 0,
                recurring: this.recurring,
            };

            if (this.newSelectedModalClient.id === undefined) {
                this.newSelectedModalClient.id = this.bookData.client_id;
            }
            //change required keys if its client appointment
            if (this.apptClientSelected || !this.personal) {
                data["personal"] = typeof this.bookData.personal != "undefined" ? this.bookData.personal : false;
                data["client_id"] = this.newSelectedModalClient.id;
                data["services"] = selectedServicesID;
            } else {
                data["status"] = "confirmed";
                data["current_user_id"] = data["user_id"];
            }

            if (this.bookData.id) {
                data["id"] = this.bookData.id;
            }

            if (this.clientConfirmed) {
                data["status"] = "confirmed";
            }

            if (data["recurring"]) {
                data["repeat_every"] = this.repeatEvery;
                data["repeat_period"] = this.repeatPeriod;
                data["repeat_times"] = this.repeatTimes;
                data["repeat_week_days"] = this.repeatWeekdays;
            }

            //if its an update request, always have update_recurring 1
            if (typeof data["id"] !== "undefined" && data["id"] && data["recurring"]) {
                data["update_recurring"] = 1;
            }

            let policy = this.clientWidgetSettings.stylist_policy;

            if (this.user.role == "client" && data["id"] != 0 && policy.reschedule == 1 && policy.reschedule_fee > 0) {
                let appt_date_time = moment(this.bookData.original_date).unix();
                let current_date_time = moment().unix();
                let hours_diff = (appt_date_time - current_date_time) / 3600;

                if (hours_diff <= policy.reschedule_advance_hours && this.newTotalCostServices > 0) {
                    data["reschedule_fee"] = this.newTotalCostServices * (policy.reschedule_fee / 100);
                }
            }

            this.$http.post(api.actions.save_appointment, data).then(
                function (response) {
                    if (this.personal === true) {
                        this.appSwitch();
                        $("#appointment-type-selector").prop("checked", false);
                    }
                    this.personal = false;
                    if (response.data.error) {
                        messages.errorMessage(response.data.message);

                        this.resetData();

                        // Hide event-modal in bootstrap 5
                        const dateModalEl = document.getElementById("date-modal");
                        const dateModalInstance = Modal.getInstance(dateModalEl) || new Modal(dateModalEl);
                        dateModalInstance.hide();
                    }
                    if (response.data.error == false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.APPOINTMENT_SAVED);

                        this.newDisableSave = true;

                        // Hide event-modal in bootstrap 5
                        const eventModalEl = document.getElementById("event-modal");
                        const eventModalInstance = Modal.getInstance(eventModalEl) || new Modal(eventModalEl);
                        eventModalInstance.hide();

                        if (this.user.role == "stylist") {
                            this.newCurrentStylist = this.newUsers.find(
                                (user) => user.user.id == this.newCurrentStylistId,
                            );
                        }
                        this.numberOfDataFetched = 0;
                        this.totalNumberOfDataToFetch = 2;
                        this.newGetDisabledTimes(this.newCurrentStylist);
                        this.newGetAppointments(this.newCurrentStylist);
                        this.resetData();
                        this.editServices = false;
                        this.addServiceModal = false;

                        const dateModalEL = document.getElementById("date-modal");
                        const dateModalInstance = Modal.getInstance(dateModalEL);

                        if (dateModalInstance) {
                            dateModalInstance.hide();
                        }

                        $("#add-service-modal").slideUp();
                        $("#add-client-modal").slideUp();
                        this.resetAppointmentModalData();
                    }
                }.bind(this),
                function () {
                    return false;
                },
            );
        },

        resetAppointmentModalData() {
            this.resetData();
            this.editServices = false;
            this.addServiceModal = false;
            this.clientConfirmed = 0;
            this.newSearchQuery = "";
            this.newSearch = "";
            this.newDisableSave = true;
            this.resetAddNewClientErrors();
            this.getFreshClients();
            if (this.personal === true) {
                this.appSwitch();
                $("#appointment-type-selector").prop("checked", false);
            }

            const dateModalEL = document.getElementById("date-modal");
            const dateModalInstance = Modal.getInstance(dateModalEL);

            if (dateModalInstance) {
                dateModalInstance.hide();
            }

            $("#add-service-modal").slideUp();
            $("#add-client-modal").slideUp();
        },

        newGetAppointments(user, targetDate = null, executeLoop = false) {
            this.resetLoop();
            if (
                targetDate == null &&
                typeof this.lastFetchedAppointmentDate != "undefined" &&
                this.lastFetchedAppointmentDate != null
            ) {
                targetDate = this.lastFetchedAppointmentDate;
            }
            if (
                targetDate == null &&
                typeof this.bookData != "undefined" &&
                typeof this.bookData.date != "undefined" &&
                this.bookData.date != null
            ) {
                targetDate = this.bookData.date;
            }

            this.lastFetchedAppointmentDate = targetDate;

            if (user == null || (user != null && user.user == null)) {
                return;
            }

            let userId = user.user.id;
            this.newAppointments[userId] = [];

            let data = {
                date:
                    targetDate != null
                        ? moment(targetDate).format("YYYY-MM-DD hh:mm:ss")
                        : moment().format("YYYY-MM-DD hh:mm:ss"),
                weeks_before: this.weeks_before,
                weeks_after: this.weeks_after,
                include_canceled: false,
            };

            if (this.newIsGroup) {
                data.group_user_id = userId;
            } else if (this.groupMemberDisplayAll) {
                data.group_user_id = userId;
                data.group_admin_id = this.groupAdminId;
            }

            var method = this.user.role == "stylist" ? "get_stylist_appointments" : "get_client_appointments";
            this.calendarApptsReady = false;

            return this.$http.post(api.actions[method], data).then(
                async function (response) {
                    this.weeks_before = 6;
                    this.weeks_after = 6;
                    this.loading = false;
                    let self = this;
                    if (!response.data.error) {
                        let today = moment();
                        this.appointmentRefreshTime = today.format("h:mm:ss a");

                        if (this.user.role == "client") {
                            let finalObj = {};

                            response.data.appointments.forEach((appt, key) => {
                                appt.dayDate = appt.date.split(" ")[0];
                                if (self.user && self.user.role == "client") {
                                    appt.services_array = appt.services ? appt.services.split(";") : [];
                                    appt.services_qty = appt.services_qty ? appt.services_qty.split(";") : [];

                                    appt.services_images_array = appt.services_images
                                        ? appt.services_images.split(";")
                                        : [];
                                    appt.services_description_array = appt.services_description
                                        ? appt.services_description.split(";")
                                        : [];

                                    let duration = appt.duration ? appt.duration : 15;
                                    let endDate = moment(appt.date).add(duration, "minutes");
                                    let start = moment(appt.date).format("hh:mm A");
                                    let end = endDate.format("hh:mm A");
                                    appt.end_date = endDate.format("YYYY-MM-DD HH:mm:ss");
                                    appt.start = start;
                                    appt.end = end;
                                }

                                const myDate = moment(appt.dayDate, "YYYY-MM-DD");
                                //if date is not in past
                                if (today.diff(myDate, "days") <= 0) {
                                    finalObj[key] = appt;
                                }
                            });
                            this.dateAppointments = finalObj;
                        }
                        this.newAppointments[userId] = response.data.appointments;
                    }
                    this.firstLoad = false;
                    this.numberOfDataFetched++;

                    this.newMakeEvents(executeLoop);

                    let openEventId = sessionStorage.getItem("openEventId");

                    if (openEventId) {
                        sessionStorage.setItem("openEventId", "");

                        this.selected_event = _.find(this.newAppointments[this.newCurrentStylistId], {
                            id: openEventId,
                        });

                        if (this.user.role == "client") {
                            this.viewAppointmentDetails({ id: openEventId });
                        }

                        if (this.selected_event) {
                            this.newOnEventClick({
                                event: { id: openEventId },
                            });
                        } else {
                            this.$http
                                .post(api.actions.get_stylist_appointments, {
                                    appointment_id: openEventId,
                                })
                                .then((response) => {
                                    if (!response.data.error) {
                                        if (!response.data.appointments[0]) {
                                            return;
                                        }

                                        this.newAppointments[userId].push(response.data.appointments[0]);
                                        this.newOnEventClick({
                                            event: {
                                                id: openEventId,
                                                date: response.data.appointments[0].date,
                                            },
                                        });
                                    }
                                });
                        }
                    }

                    this.resetLoop();

                    if (this.initCalendar || executeLoop) {
                        let intId = setInterval(() => {
                            this.appointmentRefreshTimeCounter -= 1;
                            this.$data.executeNextLoopIn -= 1000;

                            if (this.executeNextLoopIn < 1000) {
                                if (!this.$refs.fullCalendar) {
                                    return;
                                }

                                var calendarApi = this.getFullCalendarApi();
                                var dates = {
                                    start: calendarApi.view.currentStart,
                                    end: calendarApi.view.currentEnd,
                                };

                                this.newGetAppointments(this.getCurrentUserObject(user), dates.start, true);
                                clearInterval(intId);
                            }
                        }, 1000);

                        this.initCalendar = false;
                    }

                    this.calendarApptsReady = true;

                    await this.$nextTick();
                    return true;
                }.bind(this),
                function () {
                    return false;
                },
            );
        },

        getAppointmentsByStatus() {
            var calendarApi = this.getFullCalendarApi();

            if (!calendarApi || !calendarApi.view) {
                console.warn("Calendar API not ready yet");
                return;
            }
            var view = calendarApi.view;
            var startTime = moment(view.currentStart).unix();
            var endTime = moment(view.currentEnd).unix();

            var appointments = [];
            this.resetStatusFilterTypeAppts();

            if (this.user.role == "stylist" && this.showStylistSpecificAppointments) {
                appointments = this.newAppointments[this.newCurrentStylistId];
            } else if (this.user.role == "stylist" && !this.showStylistSpecificAppointments) {
                this.newUsers.forEach((userProfile) => {
                    appointments = _.concat(appointments, this.newAppointments[userProfile.user.id]);
                });
            } else {
                appointments = this.newAppointments[this.user.id];
            }

            if (!appointments || _.isEmpty(appointments)) {
                this.resetStatusFilterTypeAppts();
                return;
            }

            appointments.forEach((el) => {
                var aptTime = moment(el.date).unix();
                if (aptTime >= startTime && aptTime <= endTime) {
                    if (el.status == "unconfirmed") {
                        this.statusFilterTypeAppts["unconfirmed"].push(el);
                    } else if (el.status == "confirmed") {
                        this.statusFilterTypeAppts["confirmed"].push(el);
                    } else if (el.status == "paid") {
                        this.statusFilterTypeAppts["checked-in"].push(el);
                    } else if (el.status == "canceled" && !el.cancel_details) {
                        this.statusFilterTypeAppts["cancellation"].push(el);
                    } else if (el.status == "canceled" && el.cancel_details) {
                        this.statusFilterTypeAppts["no-show"].push(el);
                    }

                    this.statusFilterTypeAppts["total"].push(el);

                    if (el.recurring) {
                        this.statusFilterTypeAppts["recurring"].push(el);
                    }
                }
            });
        },

        resetStatusFilterTypeAppts() {
            this.statusFilterTypeAppts = {
                unconfirmed: [],
                confirmed: [],
                "checked-in": [],
                "checked-out": [],
                "no-show": [],
                cancellation: [],
                total: [],
                recurring: [],
            };
        },

        handleCancelRecurring() {
            this.cancelAppointment(true);
        },

        newOnEventClick(info) {
            // FIX 1: Prevent the click from bubbling down to the date cell
            if (info && info.jsEvent) {
                info.jsEvent.stopPropagation();
            }

            let userId = this.newCurrentStylistId;

            if (
                typeof info.event != "undefined" &&
                typeof info.event.extendedProps != "undefined" &&
                typeof info.event.extendedProps.user_id != "undefined"
            ) {
                userId = info.event.extendedProps.user_id;
            }
            let calendarEvent = info.event;

            if (calendarEvent.id == 0) {
                return;
            }

            this.selected_event = {};
            this.selected_event = _.find(this.newAppointments[userId], {
                id: parseInt(calendarEvent.id),
            });

            if (info.appt) {
                this.searchQuery = null;
                this.filteredAppointments = [];
            }

            if (!this.selected_event && info.appt) {
                this.selected_event = info.appt;

                this.selected_event = {
                    booked_by: info.appt.booked_by,
                    date: info.appt.date,
                    duration: info.appt.total_duration,
                    end: info.appt.hour_end,
                    end_date: moment(info.appt.date).add(info.appt.total_duration, "minutes"),
                    id: info.appt.id,
                    notes: info.appt.notes,
                    price: info.appt.total_cost,
                    recurring: info.appt.recurring,
                    services: info.appt.services,
                    services_array: info.appt.services_array,
                    services_colors: [],
                    services_full: [],
                    services_ids: "",
                    showServices: info.appt.show,
                    start: info.appt.hour_begin,
                    status: info.appt.status,
                    user_id: info.appt.user_id,
                    with_name: info.appt.client.full_name,
                    client_email: info.appt.client.email,
                    client_phone: info.appt.client.phone,
                };
            }

            if (!this.selected_event) {
                return;
            }

            // Round the price
            if (this.selected_event.price) {
                this.selected_event.price = parseFloat(this.selected_event.price.toFixed(2));
            }

            if (typeof this.selected_event.services == "string" && this.selected_event.services) {
                this.selected_event.services_array = this.selected_event.services.split(";");
            } else {
                this.selected_event.services_array = [];
            }

            if (!this.selected_event.notes) {
                this.selected_event.notes = "There were no notes made";
            }

            if (
                (!this.selected_event.services_array || !this.selected_event.services_array.length) &&
                this.selected_event.status == "confirmed"
            ) {
                this.selected_event.status = "PERSONAL TIME OFF";
            }

            if (
                !this.selected_event.services_array ||
                (!this.selected_event.services_array.length && this.selected_event.status == "unconfirmed")
            ) {
                this.selected_event.status = "PERSONAL TIME OFF";
            }

            this.initials = [];
            let name = this.selected_event.with_name;
            let nameArray = name.split(" ");
            if (nameArray.length && typeof nameArray[0][0] !== "undefined") {
                this.initials.push(nameArray[0][0].toUpperCase());
            }
            if (nameArray.length > 1 && typeof nameArray[1][0] !== "undefined") {
                this.initials.push(nameArray[1][0].toUpperCase());
            }

            const eventByStatusModalEL = document.getElementById("event-by-status-modal");
            const eventByStatusModalInstance = Modal.getInstance(eventByStatusModalEL);

            if (eventByStatusModalInstance) {
                eventByStatusModalInstance.hide();
            }

            const eventModal = document.getElementById("event-modal");
            const modalEventInstance = Modal.getInstance(eventModal) || new Modal(eventModal);

            // Fetch appointment details
            this.$http.get(api.actions.get_appointment_details + this.selected_event.id + "?webRequest=1").then(
                function (response) {
                    if (response.data) {
                        this.appointment_details = response.data;

                        this.selectedServicesArray = response.data.services.map((service) => ({
                            ...service,
                            selected: Boolean(service.selected),
                        }));

                        let details = response.data.details;
                        let selected_services = _.filter(response.data.services, { selected: 1 });
                        let selected_service_ids = _.map(selected_services, (el) => el.service_id);
                        let selected_service_names = _.map(selected_services, (el) => el.service_name);

                        // Reset payment states
                        this.stripeCards = [];
                        this.squareCards = [];
                        this.cardsLoaded = false;
                        this.paymentProcess = false;
                        this.showCheckout = false;

                        this.amount =
                            parseFloat(this.appointment_details.total_price) -
                            parseFloat(this.appointment_details.details.total_payments || 0);
                        this.appointment_paid = this.amount <= 0;

                        this.recurringDetails = details.recurring_details;
                        this.recurring = details.recurring;

                        this.bookData = {
                            id: details.id,
                            stylist_id: details.user_id,
                            client_id: details.client_id,
                            services: selected_service_ids,
                            date: moment(details.date).toDate(),
                            special_event: details.special_event,
                            notes: details.notes,
                            reminders: details.reminders.split(","),
                            personal: details.personal,
                        };

                        // Sync the date displays for the Modal
                        this.day = moment(this.bookData.date).format("ddd");
                        this.date = moment(this.bookData.date).format("l");
                        this.hour = moment(this.bookData.date).format("hh:mm A");

                        if (auth.state.user.role == "stylist") {
                            this.currentSection = 2;
                            this.newCurrentStylistId = details.user_id;

                            // FIX 2: Instead of calling this.newOnDateClick(),
                            // just run the internal logic needed to prepare the date state
                            this.day = moment(this.bookData.date).format("ddd");
                            this.date = moment(this.bookData.date).format("l");
                            this.hour = moment(this.bookData.date).format("hh:mm A");

                            // Logic formerly hidden inside newOnDateClick that sets the specific time
                            // but DOES NOT trigger the DateModal.show() call.
                            this.newManageSaveAppointmentButton();
                        }

                        this.$http
                            .post(api.actions.get_square_locations, {
                                stylist_id: this.bookData.stylist_id,
                            })
                            .then((response) => {
                                if (response.data.error == false || response.data.locations) {
                                    this.square_location_id = response.data.locations[0].id;
                                }
                            });

                        this.updateSelectedServices();
                        modalEventInstance.show();
                    }
                }.bind(this),
            );

            if (this.user.role == "client") {
                this.prevent_clients_reschedule = this.selected_event.prevent_clients_reschedule;
            }
        },

        editPersonalAppt(appt) {
            if (appt.status === "PERSONAL TIME OFF") {
                this.setAppointmentType("personal");
                this.changeRepeatPeriod(appt.repeat_period);

                this.editPersonalAppointment = true;

                const eventModalEl = document.getElementById("event-modal");
                const eventModalInstance = Modal.getInstance(eventModalEl) || new Modal(eventModalEl);
                eventModalInstance.hide();

                setTimeout(() => {
                    const dateModalEL = document.getElementById("date-modal");
                    const dateModalInstance = Modal.getInstance(dateModalEL) || new Modal(dateModalEL);
                    if (dateModalInstance) {
                        dateModalInstance.show();
                    }
                }, 200);

                this.newTotalDurationServices = parseInt(appt.duration);
                this.disable = true;
                this.personal = true;
                this.recurring = true;
                this.repeatEvery = appt.repeat_every;
                this.repeatTimes = appt.repeat_times;

                this.apptClientSelected = !this.apptClientSelected;
                this.notes = appt.notes;
                $("#appointment-type-selector").prop("checked", true);

                this.newDisableSave = false;
            }
        },

        getButtons() {
            var buttons = $("<div>").append(
                $('<div class="mb-3">' + this.$t("adminDashboard.details.cancelAppointmentText") + "</button></div>"),
            );

            if (auth.state.user.role != "client") {
                $(buttons).append(
                    $(
                        '<div class="border-bottom border-top"><button id="noShowAppointment" type="button" class="primary-btn extra-small">' +
                            this.$t("adminDashboard.details.cancelAppointmentNoShow") +
                            "</button></div>",
                    ),
                );
            }

            $(buttons).append(
                $(
                    ' <div class="cancel-appt-btns-wrapper"><div class=""><button id="cancelAppointment" type="button" class="primary-btn">' +
                        this.$t("adminDashboard.details.cancelAppointmentYes") +
                        "</button></div>" +
                        '<div class=""><button id="dontCancelAppointment" type="button" class="secondary-btn">' +
                        this.$t("adminDashboard.details.cancelAppointmentNo") +
                        "</button></div> </div>",
                ),
            );

            return buttons;
        },
        addCancelRecurringButton() {
            this.cancelRecurringButton = $("<div>").append(
                this.createCancelRecurringButton(this.$t("adminDashboard.details.cancelRecurring")),
            );
            return this.cancelRecurringButton;
        },

        createCancelRecurringButton(text) {
            return $('<button id="cancelRecurring" type="button" class="primary-btn">' + text + "</button>");
        },

        changeRepeatPeriod(period) {
            this.repeatPeriod = period;

            if (period == "day") {
                this.repeatEvery = 1;
            }
        },

        confirmRescheduleEvent(eventDropInfo) {
            let userId = eventDropInfo.event.extendedProps.user_id;
            let calendarEvent = eventDropInfo.event;
            this.selected_event = {};
            this.selected_event = _.find(this.newAppointments[userId], {
                id: parseInt(calendarEvent.id),
            });

            if (eventDropInfo.event.extendedProps.prevent_clients_reschedule == 1 && this.user.role == "client") {
                messages.errorMessage(this.$t("adminDashboard.preventRescheduleMessage"));
                eventDropInfo.revert();
                return;
            }

            let customClassApp = "rms-app";
            document.querySelector("body").classList.add("rms-app");

            if (this.generalOptions.app_id === 2) {
                customClassApp = "rmb-app";
                document.querySelector("body").classList.add("rmb-app");
            } else if (this.generalOptions.app_id === 5) {
                customClassApp = "rml-app";
                document.querySelector("body").classList.add("rml-app");
            }

            this.$swal({
                title: this.$t("adminDashboard.details.modifyMyAppointment"),
                icon: "warning",
                customClass: customClassApp,
                showCancelButton: true,
                confirmButtonText: this.$t("adminDashboard.details.cofirmModifyApptYes"),
                cancelButtonText: this.$t("adminDashboard.details.cofirmModifyApptNo"),
            }).then((result) => {
                if (result.value) {
                    //for the data for save appointment

                    this.newCurrentStylistId = userId;
                    this.newCurrentStylist = this.newUsers.find((user) => user.user.id == this.newCurrentStylistId);

                    this.bookData.date = eventDropInfo.event.start;
                    this.hour = moment(this.bookData.date).format("hh:mm A");

                    if (this.selected_event && this.selected_event.notes) {
                        this.notes = this.selected_event.notes;
                    }

                    this.newTotalDurationServices = moment
                        .duration(moment(eventDropInfo.event.end).diff(moment(eventDropInfo.event.start)))
                        .asMinutes();

                    this.$http.get(api.actions.get_appointment_details + this.selected_event.id + "?webRequest=1").then(
                        function (response) {
                            if (response.data) {
                                let details = response.data.details;
                                let selected_services = _.filter(response.data.services, {
                                    selected: 1,
                                });
                                let selected_service_ids = _.map(selected_services, (el) => {
                                    return el.service_id;
                                });
                                this.newTotalCostServices = 0;
                                selected_services.forEach((el) => {
                                    this.newTotalCostServices += el.service_price;
                                });

                                this.bookData.id = details.id;
                                this.bookData.stylist_id = details.user_id;
                                this.bookData.client_id = details.client_id;
                                this.bookData.services = selected_service_ids;
                                this.bookData.special_event = details.special_event;
                                this.bookData.notes = details.notes;
                                this.bookData.reminders = details.reminders.split(",");
                                this.bookData.personal = details.personal;
                                this.bookData.original_date = details.date;

                                //manage recurring
                                if (typeof details.recurring !== "undefined" && details.recurring) {
                                    this.recurring = details.recurring;
                                }
                                if (this.recurring && typeof details.recurring_details !== "undefined") {
                                    if (typeof details.recurring_details.repeat_every !== "undefined") {
                                        this.repeatEvery = details.recurring_details.repeat_every;
                                    }
                                    if (typeof details.recurring_details.repeat_period !== "undefined") {
                                        this.repeatPeriod = details.recurring_details.repeat_period;
                                    }
                                    if (typeof details.recurring_details.repeat_times !== "undefined") {
                                        this.repeatTimes = details.recurring_details.repeat_times;
                                    }
                                }

                                if (details.user_id == auth.state.user.id) {
                                    this.selectedStylist = auth.state.user;
                                } else {
                                    let stylist = _.filter(this.newUsers, {
                                        user: { id: details.user_id },
                                    });

                                    if (stylist.length > 0) {
                                        this.selectedStylist = stylist[0].user;
                                    }
                                }

                                let client = _.filter(this.newClients, {
                                    id: details.client_id,
                                });

                                if (client.length > 0) {
                                    this.selectedClient = client[0];
                                }

                                //select the client
                                if (
                                    typeof details.client !== "undefined" &&
                                    typeof details.client.first_name !== "undefined" &&
                                    typeof details.client.last_name !== "undefined" &&
                                    typeof details.client.id !== "undefined"
                                ) {
                                    this.newSelectedModalClient = {
                                        first_name: details.client.first_name,
                                        last_name: details.client.last_name,
                                        id: details.client.id,
                                    };
                                } else {
                                    this.newSelectedModalClient = _.find(this.newPagedClients, function (client) {
                                        return client.id == details.client_id;
                                    });
                                }

                                if (this.user.role == "client" && !this.newSelectedModalClient) {
                                    this.newSelectedModalClient = {
                                        first_name: this.user.first_name,
                                        last_name: this.user.last_name,
                                        id: this.user.id,
                                    };
                                    this.newCurrentStylistId = details.user_id;
                                }

                                if (this.newSelectedModalClient) {
                                    this.newIsClientSelected = true;
                                }

                                //select the services
                                this.newSelectedServices = [];
                                this.newMakeListServices();

                                let targetService = _.filter(this.newServicesArray, function (service) {
                                    return selected_service_ids.indexOf(service.id) != -1;
                                });

                                if (Object.keys(targetService).length) {
                                    this.newSelectedServices = targetService;
                                }

                                if (this.user.role == "client" && this.newSelectedServices.length == 0) {
                                    this.newSelectedServices = selected_services;
                                    this.newSelectedServices.forEach((srv, k) => {
                                        this.newSelectedServices[k].id = srv.service_id;
                                    });
                                }

                                //select the date
                                this.day = moment(this.bookData.date).format("ddd");
                                this.date = moment(this.bookData.date).format("l");

                                let policy = response.data.policy;

                                //Check the reschedule policy and display the confirmation modal
                                if (
                                    this.user.role == "client" &&
                                    details.id != 0 &&
                                    policy.reschedule == 1 &&
                                    policy.reschedule_fee > 0
                                ) {
                                    let appt_date_time = moment(details.date).unix();
                                    let current_date_time = moment().unix();
                                    let hours_diff = (appt_date_time - current_date_time) / 3600;

                                    if (
                                        hours_diff <= policy.reschedule_advance_hours &&
                                        this.newTotalCostServices > 0
                                    ) {
                                        this.$swal({
                                            title: "Reschedule Fee Required",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonText: this.$t("adminDashboard.details.cofirmYesGeneral"),
                                            cancelButtonText: this.$t("adminDashboard.details.cofirmNoGeneral"),
                                        }).then((result) => {
                                            if (result.value) {
                                                this.newSaveAppointment();
                                            } else {
                                                //revert the changes
                                                eventDropInfo.revert();
                                            }
                                        });
                                        return;
                                    }
                                }

                                this.newSaveAppointment();
                            }
                        }.bind(this),
                    );
                } else {
                    //revert the changes
                    eventDropInfo.revert();
                }
            });
        },

        getMemberColor(member, index) {
            if (typeof member.color == "undefined" || member.color == null || !member.color) {
                let color = general.colors[index];
                return "#" + color;
            }
            return member.color;
        },

        resetData() {
            this.bookData.id = 0;
            this.newSelectedModalClient = {};
            this.newIsClientSelected = false;
            this.newShowSelectedServices = false;
            this.newSelectedServicesString = "";
            this.newTotalCostServices = 0;
            this.newShowTotalCost = false;
            this.newTotalDurationServices = 0;
            this.newShowTotalDuration = false;
            this.newSelectedServices = [];
            this.notes = "";
            this.editServices = false;
            this.addServiceModal = false;

            //reset services
            this.newUsers.forEach((user) => {
                _.each(this.newClientServices[user.user.id], (services) => {
                    services.forEach((service) => {
                        service.selected = false;
                        service.qty = 0;
                    });
                });
            });

            this.newServicesArray.forEach((service) => {
                this.selectedServiceQty[service.id] = 1;
            });

            this.recurring = 0;
            this.repeatEvery = 0;
            this.repeatPeriod = "week";
            this.repeatTimes = 0;

            const eventModalEl = document.getElementById("event-modal");
            const eventModalInstance = Modal.getInstance(eventModalEl) || new Modal(eventModalEl);
            eventModalInstance.hide();
        },

        displayCancelButton(event) {
            var date = moment(event.date, "YYYY-MM-DD hh:mm A");
            var isFutureEvent = date.isAfter(moment().toDate());
            var isStylist = auth.state.user?.role === "stylist";

            return isFutureEvent || isStylist;
        },

        eventContent(info) {
            const container = document.createElement("div");
            container.innerHTML = info.event.title;

            if (info.event.extendedProps.recurring === 1) {
                const icon = document.createElement("i");
                icon.className = "static-recurring-sign fa fa-refresh";
                container.appendChild(icon);
            }

            this.setDateLabelPos(); // now `this` points to Vue component

            if (this.eventRendering) {
                clearTimeout(this.eventRenderTimeout);
                this.eventRenderTimeout = setTimeout(() => {
                    this.getAppointmentsByStatus();
                    this.eventRendering = false;
                }, 500);
            } else {
                this.eventRendering = true;
            }

            return { domNodes: [container] };
        },

        eventResize(eventDropInfo) {
            this.confirmRescheduleEvent(eventDropInfo);
        },

        eventDrop(eventDropInfo) {
            this.confirmRescheduleEvent(eventDropInfo);
        },
    },
};
